import React__default from 'react';
import styled from '../../../../node_modules/@mui/material/styles/styled.mjs';

const StyledContainer = styled('div')(({ theme })=>({
        background: theme.styleConfig.container.backgroundColor,
        borderStyle: 'solid',
        borderWidth: theme.styleConfig.container.borderWidth,
        borderColor: theme.styleConfig.container.borderColor,
        borderRadius: theme.styleConfig.container.borderRadius,
        color: theme.styleConfig.colors.primary,
        width: theme.styleConfig.container.width,
        padding: theme.styleConfig.container.padding,
        boxSizing: 'border-box'
    }));
const MainContainer = ({ children })=>{
    return /*#__PURE__*/ React__default.createElement(StyledContainer, null, children);
};

export { MainContainer };
//# sourceMappingURL=MainContainer.mjs.map
